// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class Toggler extends WebComponent {
	didMount() {
    const {
      toggleClass,
      target,
    } = this.props;

    this.on('click', () => {
        this.element.classList.toggle(toggleClass);
        const targetElement = document.querySelector(target);
        targetElement.classList.toggle(toggleClass);
        const openToggles = document.querySelectorAll('.' + toggleClass);

        openToggles.forEach((toggle) => {
          if ((toggle != this.element) && (toggle != targetElement)) {
            toggle.classList.remove(toggleClass);
          }
        });
    });
	}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Toggler.js